import React from 'react';
import ReactDOM from 'react-dom';

import './Backdrop.css';

function Backdrop(props) {
  function backdropClose() {
    props.onBackdropClose();
  }

  const content = (
    <>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions -- scrim behind the drawer/modal; click to close is a mouse convenience only, every consumer renders its own close control so the scrim must not become a tab stop */}
      <div
        id="backdrop_holder"
        className={props.open}
        role="presentation"
        onClick={backdropClose}
      />
      {props.children}
    </>
  );
  return ReactDOM.createPortal(content, document.getElementById('sidebar'));
}
export default Backdrop;
